import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { DashboardLayout } from '../layouts';
import FolderItems from '../views/FolderItems';
import { AccentButton } from '../components/Button';

import { useItems } from '../../hooks/useFolder';

const TrashPage = () => {
  const navigate = useNavigate();

  const { items, isLoading, deleteItem } = useItems(null, { trashed: true });
  const [searchQuery, setSearchQuery] = useState('');
  const [activeMenuItem, setActiveMenuItem] = useState('trash');

  const handleMenuItemClick = (item) => {
    setActiveMenuItem(item.id);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleEmptyTrash = async () => {
    await Promise.all(items.map((item) => deleteItem(item.id)));
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white dark:bg-[#121212]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#121212] dark:border-[#D0D0D0]"></div>
      </div>
    );
  }

  return (
    <DashboardLayout
      activeMenuItem={activeMenuItem}
      onMenuItemClick={handleMenuItemClick}
      searchQuery={searchQuery}
      onSearchChange={handleSearchChange}
      onBackClick={() => navigate('/my')}
      onForwardClick={() => {}}
      onProfileClick={() => {}}
    >
      {/* Trash Section Header */}
      <div className="border-b border-[#ECECEC] dark:border-[#202020] bg-white dark:bg-[#121212]">
        <div className="h-[70px] flex items-center justify-between px-6">
          <h2 className="text-xl font-medium text-[#121212] dark:text-[#D0D0D0]">
            Trash Bin
          </h2>
          <div className="flex items-center gap-4">
            <AccentButton variant="primary" onClick={handleEmptyTrash}>Empty Trash</AccentButton>
          </div>
        </div>
      </div>

      {/* Items Grid */}
      <div className="p-6">
        <FolderItems items={items} isTrash />
      </div>
    </DashboardLayout>
  );
};

export default TrashPage;
